import React from 'react';
export var highlightMatch = function highlightMatch(label, searchQuery) {
  if (!label || !searchQuery || typeof searchQuery !== 'string') {
    return '';
  }

  var index = label.toLowerCase().indexOf(searchQuery.toLowerCase());

  if (index !== -1) {
    var highlightPortion = label.substring(index, index + searchQuery.length);
    var prefix = '';
    var suffix = '';

    if (index === 0) {
      suffix = label.substring(searchQuery.length);
      return React.createElement(React.Fragment, null, React.createElement("strong", null, highlightPortion), suffix);
    }

    prefix = label.substring(0, index);
    suffix = label.substring(index + searchQuery.length);
    return React.createElement(React.Fragment, null, prefix, React.createElement("strong", null, highlightPortion), suffix);
  }

  return label;
};